import {
  Component, Inject, OnDestroy, OnInit,
} from '@angular/core';
import {
  MAT_DIALOG_DATA, MatDialog, MatDialogRef,
} from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { VerificationComponent } from 'src/app/components/verification/verification.component';
import { ApprovalService } from 'src/app/services/approval.service';
import { CourseRequestsService } from 'src/app/services/course-requests.service';
import { EntityService } from 'src/app/services/entity.service';
import { LoadingSpinnerService } from 'src/app/services/loading-spinner.service';
import { ToastService } from 'src/app/services/toast.service';
import { ValidationService } from 'src/app/services/validation.service';
import { firstValueFrom } from 'rxjs';
import { ViewChild } from '@angular/core';
import { CourseRequestAttachmentsComponent } from './components/course-request-attachments/course-request-attachments.component';
import { PendingFileInfo } from 'src/app/components/upload-file/upload-file.component';

@Component({
  selector: 'app-update-my-course-request',
  templateUrl: './update-my-course-request.component.html',
  styleUrls: [ './update-my-course-request.component.scss' ],
})
export class UpdateMyCourseRequestComponent implements OnInit, OnDestroy {
@ViewChild(CourseRequestAttachmentsComponent, { static: false })
private attachmentsStep?: CourseRequestAttachmentsComponent;
course: any = {
    name: '',
    approvalId: '',   // this should be L0_NONE
    validationId: '', // this should be HONOR
    creditHours: '',
    courseType: '',
    instructor: '',
    cost: '',
    webUrl: '',
    description: '',
    async: false,
    virtual: false,
    anytime: false,
    location: '',
    roomNumber: '',
    courseDate: '',
    startTime: '',
    endTime: '',
  }
  steps = [ { completed: false, text: 'General Info' }, { completed: false, text: 'Attachments' }, { completed: false, text: 'Review & finish' } ]
  selectedStep = this.steps[0]
  entity: any;
  approvalsSubscription: any;
  entitySubscription: any;
  validationSubscription: any;
  courseTypes: any;
  courseRequestSub: any;
  originalFormattedCourse: any;
  
  noApprovalNeededId: number;

  error = {
    cost: '',
    name: '',
    description: '',
    courseType: '',
    webUrl: '',
    location: '',
    courseDate: '',
    startTime: '',
    endTime: '',
    instructor: '',
    roomNumber: '',
    creditHours: '',
    approvalId: '',
    validationId: ''
  }

  get fine() { return this.course.approvalId || this.course.validationId || this.course.cost }

  get registerDisabled() {
    if (this.selectedStep === this.steps[0]) {
      return !this.course.name || !this.course.creditHours || !this.course.courseType || !this.course.description || !this.course.location
    }
    return false
  }

  constructor(
    public dialogRef: MatDialogRef<UpdateMyCourseRequestComponent>,
    public dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public data: any,
    private approvalService: ApprovalService,
    private loadingSpinnerService: LoadingSpinnerService,
    private toastService: ToastService,
    private courseRequestsService: CourseRequestsService,
    private activatedRoute: ActivatedRoute,
    private entityService: EntityService,
    private validationService: ValidationService,
  ) { }

  ngOnInit(): void {
    this.entityService.getEntity('CourseTypes')
    this.entitySubscription = this.entityService.entityData$.subscribe((entityData: any) => {
      this.entity = entityData
      // get the active course types for the general info step. the only way to call for all the course types is through the entity.
      const activeCourseTypes = entityData?.CourseTypes?.filter((courseType: any) => courseType.activeFlag)
      this.courseTypes = activeCourseTypes
    })

    this.approvalsSubscription = this.approvalService.approvalData$.subscribe((data: any) => {
      if (!data) return;

      const noApprovalNeeded = data.find((approval: any) => approval.kalpaIdentifier === 'L0_NONE')
      this.course.approvalId = Number(noApprovalNeeded?.id);
    });
    this.validationSubscription = this.validationService.validationTypes$.subscribe((data: any) => {
      if (!data) return;
      const honorValidation = data.find((validation: any) => validation.kalpaIdentifier === 'HONOR')
      this.course.validationId = Number(honorValidation?.id);
    });

    this.approvalService.getApprovalLevels();
    this.validationService.getValidationTypes();
  }

get pendingDocuments(): PendingFileInfo[] {
  return this.attachmentsStep?.getPendingDocuments() ?? [];
}
  closeDialog = () => {
    this.dialogRef.close();
  }

  stepForward = () => {
    // Check validation before proceeding
    if (this.nextDisabledCheck()) {
      return;
    }
    
    this.selectedStep.completed = true
    this.selectedStep = this.steps[this.steps.indexOf(this.selectedStep) + 1];
  }

  stepBack = () => {
    const previousIndex = this.steps.indexOf(this.selectedStep) - 1;
    if (previousIndex >= 0) {
      this.selectedStep = this.steps[previousIndex];
      // When going back to General Info step, ensure validation is re-evaluated
      if (this.selectedStep === this.steps[0]) {
        // Trigger change detection to re-evaluate validation
        setTimeout(() => {
          // The child component will emit validation status via ngOnChanges/ngAfterViewInit
        }, 0);
      }
    }
  }

  // Track validation state from child components
  generalInfoValidation: { isValid: boolean } = { isValid: false };

  nextDisabledCheck = () => {
    if (this.selectedStep === this.steps[0]) {
      // Use validation from child component
      return !this.generalInfoValidation.isValid;
    }
    return false;
  }

  onGeneralInfoValidationChange = (validation: { isValid: boolean }) => {
    this.generalInfoValidation = validation;
  }

  submitCourseRequest = () => {
    if (this.course.async) {
      delete this.course.courseDate;
    }
    Object.keys(this.course).forEach((key) =>
      (this.course[key] === null || this.course[key] === '') && delete this.course[key]
    );

    this.loadingSpinnerService.setIsLoading(true);

    // Get profile user's loginName and userId from dialog data if available (when manager is submitting for another user)
    const profileUserLoginName = this.data?.profileUserLoginName;
    const profileUserId = this.data?.profileUserId;

    this.courseRequestSub = this.courseRequestsService.submitCourseRequest(
      this.course,
      profileUserLoginName,
      profileUserId
    ).subscribe({
      next: async (response: any) => {
        try {
          // Check if the request was successful
          if (response?.statusCode === 1000 || response?.data) {
            let courseItemId: number | null = null;
            let courseId: number | null = null;

            if (response?.data?.course?.CourseItems) {
              if (Array.isArray(response.data.course.CourseItems) && response.data.course.CourseItems.length > 0) {
                const item = response.data.course.CourseItems[0];
                courseItemId = Number(item.id);
                courseId = Number(item.courseId);
              }
            }

            if ((!courseItemId || isNaN(courseItemId)) && response?.data?.CourseItems) {
              if (Array.isArray(response.data.CourseItems) && response.data.CourseItems.length > 0) {
                const item = response.data.CourseItems[0];
                courseItemId = Number(item.id);
                courseId = Number(item.courseId);
              } else if (typeof response.data.CourseItems === 'object') {
                courseItemId = Number(response.data.CourseItems.id);
                courseId = Number(response.data.CourseItems.courseId);
              }
            }

            if (!courseItemId || isNaN(courseItemId)) {
              const possibleIds = [
                response?.data?.courseItemId,
                response?.data?.course_item_id,
                response?.body?.data?.courseItemId,
                response?.body?.data?.course_item_id
              ];

              for (const id of possibleIds) {
                if (id !== undefined && id !== null && id !== '') {
                  const numId = Number(id);
                  if (!isNaN(numId) && numId > 0) {
                    courseItemId = numId;
                    break;
                  }
                }
              }
            }

            if (!courseItemId || isNaN(courseItemId)) {
              const locationHeader =
                response?.headers?.get?.('Location') ||
                response?.headers?.get?.('location') ||
                response?.headers?.Location ||
                response?.headers?.location;

              if (locationHeader && typeof locationHeader === 'string') {
                const match = locationHeader.match(/course-items\/(\d+)/i) || locationHeader.match(/(\d+)(?!.*\d)/);
                if (match) {
                  courseItemId = Number(match[1]);
                }
              }
            }

            // Check if there are pending documents to upload
            const hasPendingDocuments = this.attachmentsStep?.getPendingDocuments?.()?.length > 0;

            if (hasPendingDocuments && courseItemId && !isNaN(courseItemId) && courseItemId > 0) {
              // Has documents to upload and valid courseItemId
              try {
                this.attachmentsStep?.setCourseIdsFromData?.(response.data.course || response.data || response);
                
                await this.attachmentsStep?.uploadFilesForCourse?.(courseItemId);
              } catch (err) {
                // Attachment upload failed - continue anyway
              } finally {
                this.loadingSpinnerService.setIsLoading(false);
                this.dialogRef.close(response);
              }
            } else {
              // No documents to upload or no valid courseItemId, close spinner and dialog immediately
              this.loadingSpinnerService.setIsLoading(false);
              this.dialogRef.close(response);
            }
          } else {
            // Request was not successful
            this.loadingSpinnerService.setIsLoading(false);
            const errorMessage = response?.message || 'The course request could not be submitted. Please try again.';
            this.toastService.setToast({
              text: errorMessage,
              type: 'error',
              dismissible: false,
              icon: true,
            });
          }
        } catch (err) {
          // Catch any unexpected errors during response processing
          this.loadingSpinnerService.setIsLoading(false);
          this.toastService.setToast({
            text: 'An unexpected error occurred while processing the course request. Please try again.',
            type: 'error',
            dismissible: false,
            icon: true,
          });
        }
      },
      error: (error) => {
        // Always close the spinner on error
        this.loadingSpinnerService.setIsLoading(false);
        
        // Extract error message
        const errorMessage = 
          error?.error?.pgErrorInfo?.message ||
          error?.error?.message ||
          error?.message ||
          'Something went wrong. Please try again.';
        
        // Show toast message
        this.toastService.setToast({
          text: errorMessage,
          type: 'error',
          dismissible: false,
          icon: true,
        });
      },
    });
  };

  ngOnDestroy(): void {
    this.entitySubscription?.unsubscribe();
    this.courseRequestSub?.unsubscribe();
  }

}